import theme from "themes/Theme";
import { IconProps } from "./IconProps";

const TransactionStatsIcon: React.FC<IconProps> = ({
  width = 64,
  height = 64,
}) => {
  return (
    <svg viewBox="0 0 576 512" width={width} height={height}>
      <path
        d="M512 32h-448c-35.35 0-64 28.66-64 64L0 128h576V96C576 60.66 547.3 32 512 32zM0 416c0 35.34 28.65 64 64 64h448c35.35 0 64-28.66 64-64V224H0L0 416zM191.1 360c0-4.422 3.582-8 8-8h143.1c4.418 0 8 3.578 8 8L352 376c0 4.418-3.582 8-8 8h-144C195.6 384 192 380.4 192 376L191.1 360zM63.1 360c0-4.422 3.582-8 8-8h80c4.418 0 8 3.578 8 8L160 376C160 380.4 156.4 384 152 384h-80C67.58 384 64 380.4 64 376L63.1 360z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
};

export default TransactionStatsIcon;
